<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div class="box" v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <!-- 头部菜单 -->
      <header class="backImg">
        <div class="HeadQueryCount backImg" v-text="datas.scan_count"></div>
        <img class="HeadQueryCountRotate" src="/static/images/Line.png">

        <div class="QueryResult GreenBg" v-if="datas.scan_count <= 1"><span
            class="icon iconfont icondunpai QueryResultIcon"></span>首次查询 正品认证</div>
        <div class="QueryResult RedBg" v-else><span class="icon iconfont iconbaojing QueryResultIcon"></span>多次查询 谨防假冒
        </div>

        <ul class="HeadNavBox">
          <li class="HeadNavRow HeadNavRowLeft">
            <p class="HeadNavTitle">首次查询时间</p>
            <p class="HeadNavTxt" v-text="datas.scan_first_time"></p>
          </li>
          <li class="HeadNavRow HeadNavRowContent">
            <p class="HeadNavTitle">首次查询地点</p>
            <p class="HeadNavTxt">
              <a v-if="datas.scan_first_address" v-text="datas.scan_first_address"></a>
              <a v-else>正在获取中...</a>
            </p>
          </li>
          <li class="HeadNavRow HeadNavRowRight" @click="ViewMore(1)">
            <p class="HeadNavTitle">扫码记录</p>
            <p class="HeadNavTxt">查看更多<span class="icon iconfont iconyou"></span></p>
          </li>
        </ul>
      </header>

      <section>

        <!-- 查询输入框 -->
        <div class="MainDatasBox NoBottom" style="padding-bottom: 0;" v-if="datas.antifake_is_show">
          <input class="MainDataInquire" v-model="verify" @keyup.enter="InquireFun" placeholder="请在此输入防伪码" />
          <i class="MainDataInquireBtn" @click="InquireFun">查询</i>
        </div>

        <!-- 查询信息 -->
        <div class="MainBox" v-if="queryContent">
          <div class="MainTitle">查询信息</div>
          <div class="MainDatasBox">
            <ul class="MainData">
              <li class="MainDataLeft">首次查询地点</li>
              <li class="MainDataRight" v-text="queryContent.query_first_address"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">首次查询时间</li>
              <li class="MainDataRight" v-text="queryContent.query_first_time"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">查询次数</li>
              <li class="MainDataRight" v-text="queryContent.query_count"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">查询记录</li>
              <li class="MainDataRight blueColor" @click="ViewMore(2)">点击查看全部 》</li>
            </ul>
            <ul class="MainData">
              <li class="MainDataTip" v-if="queryContent.query_count > 1 && !datas.many_antifake_msg">您查询的码标已经被多次扫描，谨防假冒!</li>
              <li class="MainDataTip" v-if="queryContent.query_count > 1 && datas.many_antifake_msg" >{{ datas.many_antifake_msg }}</li>
              <li class="MainDataTip" v-if="queryContent.query_count <= 1 && !datas.first_antifake_msg" >您查询的是 {{ datas.business.name }} 的正牌产品，请您放心使用!</li>
              <li class="MainDataTip" v-if="queryContent.query_count <= 1 && datas.first_antifake_msg" >{{ datas.first_antifake_msg }}</li>
            </ul>
          </div>
        </div>

        <!-- 焦点图 -->
        <div class="MainBox" v-if="datas.product && datas.prod_is_show == 1">
          <div class="swiper-container banner">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
            </div>
          </div>
        </div>

        <!-- 数字码信息 -->
        <div class="MainBox" v-if="datas.batch_code">
          <div class="MainTitle">码标</div>
          <div class="MainDatasBox">
            <ul class="MainData">
              <li class="MainDataLeft">数字码</li>
              <a ><li class="MainDataRight" v-text="datas.code"></li></a>
            </ul>
          </div>
        </div>

        <!-- 产品信息 -->
        <div class="MainBox" v-if="datas.product && datas.prod_is_show == 1">
          <div class="MainTitle">产品信息</div>
          <div class="MainDatasBox">
            <ul class="MainData" v-if="datas.attribute && datas.attribute.ship_date">
              <li class="MainDataLeft">生产日期</li>
              <li class="MainDataRight" v-text="datas.attribute.ship_date"></li>
            </ul>
            <ul class="MainData" v-if="datas.prod_name_is_show == 1">
              <li class="MainDataLeft">品名</li>
              <li class="MainDataRight" v-text="datas.product.name"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.period && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">保质期</li>
              <li class="MainDataRight" v-text="datas.product.period"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.unit && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">规格</li>
              <li class="MainDataRight" v-text="datas.product.unit"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.introduce && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">介绍</li>
              <li class="MainDataRight" v-text="datas.product.introduce"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.minSalesUnit">
              <li class="MainDataLeft">最小销售单位</li>
              <li class="MainDataRight" v-text="datas.product.minSalesUnit"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.product_sz_code">
              <li class="MainDataLeft">产品批次码</li>
              <li class="MainDataRight" v-text="datas.product.product_sz_code"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.productTypeName">
              <li class="MainDataLeft">数字平台产品类型</li>
              <li class="MainDataRight" v-text="datas.product.productTypeName"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.standards">
              <li class="MainDataLeft">产品执行标准</li>
              <li class="MainDataRight" v-text="datas.product.standards"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.phone">
              <li class="MainDataLeft">联系方式</li>
              <li class="MainDataRight" v-text="datas.product.phone"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.permitNo">
              <li class="MainDataLeft">生产许可证编号</li>
              <li class="MainDataRight" v-text="datas.product.permitNo"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.model">
              <li class="MainDataLeft">型号</li>
              <li class="MainDataRight" v-text="datas.product.model"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.entrustCompany">
              <li class="MainDataLeft">委托商</li>
              <li class="MainDataRight" v-text="datas.product.entrustCompany"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.entrustAddress">
              <li class="MainDataLeft">委托商地址</li>
              <li class="MainDataRight" v-text="datas.product.entrustAddress"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.auth3cNo">
              <li class="MainDataLeft">3C认证编号</li>
              <li class="MainDataRight" v-text="datas.product.auth3cNo"></li>
            </ul>
            <template v-if="datas.product.attribute" v-for="val in datas.product.attribute">
               <ul class="MainData" v-if="val.key || val.value">
                <template v-if='val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")'>
                  <img class="img-box" :src="val.value" />
                </template>
                <template v-else>
                  <li class="MainDataLeft" v-text="val.key"></li>
                  <li class="MainDataRight" v-text="val.value"></li>
                </template>
              </ul>
            </template>
          </div>
        </div>

        <!-- 工厂流通演示 -->
        <div class="MainBox" v-if="datas.source">
          <div class="MainTitle">工厂信息</div>
          <div class="MainDatasBox">
            <ul class="MainData" v-if="datas.source.supplier_visible === 1">
              <li class="MainDataLeft">供应商</li>
              <li class="MainDataRight" v-text="datas.source.supplier_name"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">物料名称</li>
              <li class="MainDataRight" v-text="datas.source.material_name"></li>
            </ul>
            <ul class="MainData" v-if="datas.source.stock_batch_no">
              <li class="MainDataLeft">进货批次号</li>
              <li class="MainDataRight" v-text="datas.source.stock_batch_no"></li>
            </ul>
            <ul class="MainData" v-if="datas.source.stock_date">
              <li class="MainDataLeft">进货日期</li>
              <li class="MainDataRight" v-text="datas.source.stock_date"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">度量单位</li>
              <li class="MainDataRight" v-text="datas.source.measure"></li>
            </ul>
          </div>
        </div>

        <!-- 销售流通演示 -->
        <div class="MainBox" v-if="datas.source">
          <div class="MainTitle">销售流通</div>
          <div class="MainDatasBox">
            <ul class="MainData" v-if="datas.source.distributor_visible === 1">
              <li class="MainDataLeft">经销商</li>
              <li class="MainDataRight" v-text="datas.source.distributor"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft" v-if="datas.source.sale_time_visible === 1">销售日期</li>
              <li class="MainDataRight" v-text="datas.source.sale_time"></li>
            </ul>
            <ul class="MainData" v-if="datas.source.customer_visible === 1">
              <li class="MainDataLeft">购方客户</li>
              <li class="MainDataRight" v-text="datas.source.customer"></li>
            </ul>
            <ul class="MainData" v-if="datas.source.recipient_contact_visible === 1">
              <li class="MainDataLeft">客户联系方式</li>
              <li class="MainDataRight" v-text="datas.source.recipient_contact"></li>
            </ul>
            <ul class="MainData" v-if="datas.source.recipient_addr_visible === 1">
              <li class="MainDataLeft">客户地址</li>
              <li class="MainDataRight" v-text="datas.source.recipient_province + '-' + datas.source.recipient_city + '-' + datas.source.recipient_addr"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">销售订单号</li>
              <li class="MainDataRight" v-text="datas.source.sell_order_no"></li>
            </ul>
          </div>
        </div>

        <!-- 商户信息 -->
        <viewer @inited="inited" ref="viewer">
          <div class="MainBox" v-if="datas.business && datas.business_is_show == 1">
            <div class="MainTitle">商户信息</div>
            <div class="MainDatasBox">
              <ul class="MainData" v-if="datas.business.company_idcode">
                <li class="MainDataLeft">认证中心</li>
                <li class="MainDataRight" v-text="datas.business.company_idcode"></li>
              </ul>
              <ul class="MainData">
                <li class="MainDataLeft">商户名称</li>
                <li class="MainDataRight" v-text="datas.business.name"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.linkman">
                <li class="MainDataLeft">联 系 人</li>
                <li class="MainDataRight" v-text="datas.business.linkman"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.linkphone">
                <li class="MainDataLeft">联系方式</li>
                <li class="MainDataRight" v-text="datas.business.linkphone"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.baddress">
                <li class="MainDataLeft">商户地址</li>
                <li class="MainDataRight" v-text="datas.business.baddress"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data">
                <template v-if='val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")'>
                  <img class="img-box" :src="val.value" />
                </template>
                <template v-else>
                  <li class="MainDataLeft" v-text="val.key"></li>
                  <li class="MainDataRight" v-text="val.value"></li>
                </template>
              </ul>
            </div>
          </div>

          <!-- 质检信息 -->
          <div class="MainBox" v-if="datas.batch && datas.batch_is_show == 1 && datas.batch.qc">
            <div class="MainTitle">质检信息</div>
            <div class="MainDatasBox">
              <ul class="MainData" v-for="(item, index) in datas.batch.qc" v-bind:key="index">
                <li class="MainDataLeft" v-text="item.key"></li>
                <li class="MainDataRight" v-text="item.value" v-if="item.ix == 0"></li>
                <li class="MainDataRight MainDataRightImg backImg" v-else
                  :style="{ backgroundImage: 'url(' + item.value + ')' }"><img class="OpacityImg" :src="item.value"></li>
              </ul>
            </div>
          </div>

          <!-- 生产流程 -->
          <div class="MainBox" v-if="datas.process && datas.process_is_show == 1">
            <div class="MainTitle">生产流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.process" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date.substring(0, 10)"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon"></li>
              </ul>
            </div>
          </div>

          <!-- 生产流程演示 -->
          <div class="MainBox"
            v-if="datas.process_demo && datas.process_demo.length > 0 && datas.process_demo_is_show == 1">
            <div class="MainTitle">生产流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.process_demo" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process_demo.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon"></li>
              </ul>
            </div>
          </div>

          <!-- 经销商流程 -->
          <div class="MainBox" v-if="datas.dealer && datas.dealer_is_show == 1">
            <div class="MainTitle">经销商流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.dealer" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.dealer.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date.substring(0, 10)"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon"></li>
              </ul>
            </div>
          </div>

          <!-- 视频信息 -->
          <div class="MainBox" v-if="datas.video && datas.video_is_show == 1">
            <div class="MainTitle">视频信息</div>
            <div class="MainDatasBox">
              <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox"
                :poster="datas.video.url + '?vframe/jpg/offset/1/w/400/'">
                <source :src="datas.video.url" type="video/mp4">
              </video>
            </div>
          </div>

          <!-- 自定义栏目 -->
          <div class="MainBox" v-if="datas.ref && datas.ref_is_show == 1" v-for="(item, index) in datas.ref"
            v-bind:key="index">
            <div class="MainTitle" v-text="item.name"></div>
            <ul class="MainRefDatasBox">
              <li v-for="(val, ix) in item.datas" v-bind:key="ix">
                <p class="MainRefDatasTxt" v-if="val.type == 0" v-text="val.data"></p>
                <img v-else :src="val.data">
              </li>
            </ul>
          </div>
        </viewer>

        <!-- 自定义底部菜单 -->
        <div class="MainBox" v-if="datas.menu && datas.menu_is_show == 1">
          <ul class="MainMenuRow CliclStyle" v-for="(item, index) in datas.menu" v-bind:key="index"
            @click="ClickMenu(item)">
            <li class="MainMenuIcon">
              <i v-if="item.icon" class="backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }"></i>
              <i v-else class="backImg"
                :style="{ backgroundImage: 'url(/static/images/icon' + item.type + '.png)' }"></i>
              <span class="icon iconfont iconyou MainMenuArrows"></span>
            </li>
            <li class="MainMenuDatas">
              <p class="MainMenuDatasTit onlyOneRow" v-text="item.name"></p>
              <p class="MainMenuDatasTxt onlyOneRow" v-text="item.describe"></p>
            </li>
          </ul>
        </div>

      </section>

      <K-AlertMsg :AlertMsg="AlertMsg" @AlertBack="AlertBack"></K-AlertMsg>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import AlertMsg from '@/components/AlertMsg.vue'
import Music from '@/components/Music.vue'
import Speaker from '../hook/auto.js'
import mixin from '../mixins/mixin.js'
export default {
  name: 'Normal28',
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
    'K-Music': Music
  },
  mixins: [mixin],
  data() {
    return {
      queryContent: null,
    }
  },
  created() {
    document.querySelector('body').setAttribute('style', 'background-color:#EBEFF5');

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      const pid = this.$route.query.pid; //产品ID
      const rid = this.$route.query.rid; //企业ID
      this.GetDemoDatas(pid, rid);  //获取演示模板信息
    } else {
      this.GetDatas();  //获取码标信息
    }
  },
  methods: {
    InquireFun() {
      if(!this.verify) return;
      this.queryContent = null;
      this.CodeVerify(axios, (e)=> {
        this.queryContent = e.data.meta;
        let msg;
        if(this.queryContent.query_count > 1 && !this.datas.many_antifake_msg){
          msg = "您查询的码标已经被多次扫描，谨防假冒!";
        }
        if(this.queryContent.query_count > 1 && this.datas.many_antifake_msg){
          msg = this.datas.many_antifake_msg;
        }
        if(this.queryContent.query_count <= 1 && !this.datas.first_antifake_msg){
          msg = `您查询的是 ${this.datas.business.name} 的正牌产品，请您放心使用!`;
        }
        if(this.queryContent.query_count <= 1 && this.datas.first_antifake_msg){
          msg = this.datas.first_antifake_msg;
        }
        if(msg && this.datas.antifake_auto){
          try {
            this.speaker = new Speaker({ text: msg });
            if(this.speaker){
              setTimeout(()=>{
                this.speaker.start(); // 开时播放
              },300)
            }
          } catch (error) {
            console.log(error);
          }
        }
      })
    }
  }
}
</script>
<style scoped>
header {
  padding: .5rem 0;
  font-size: .8rem;
  background-image: url(/static/images/bg.png);
  background-color: #2C5DE8;
}

.banner {
  border-radius: 0.25rem;
  overflow: hidden;
}

.banner img {
  width: 100%;
  display: block;
}

.HeadQueryCount {
  color: #C3F7FF;
  width: 5rem;
  height: 5rem;
  font-size: 1.2rem;
  text-align: center;
  line-height: 5rem;
  margin: 1.5rem auto;
  background-image: url(/static/images/CountBox.png);
}

.HeadQueryCountRotate {
  position: absolute;
  left: 0;
  right: 0;
  top: 2.05rem;
  width: 5rem;
  margin: 0 auto;
  animation: rotate 6s infinite;
  -webkit-animation: rotate 6s infinite;
  /*Safari and Chrome*/
  animation-timing-function: linear;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.QueryResult {
  padding: .2rem .8rem .3rem .8rem;
  display: table;
  margin: 0 auto;
  margin-bottom: .8rem;
  border-radius: .8rem;
  font-size: .65rem;
}

.QueryResultIcon {
  font-size: .8rem;
  margin-right: .2rem;
  position: relative;
  top: .05rem;
}

.icondunpai {
  top: .08rem;
}

.HeadNavBox {
  margin: 0 .8rem;
  overflow: hidden;
  position: relative;
  height: 1.5rem;
}

.HeadNavRow {
  color: #FFF;
  display: table;
  position: absolute;
}

.HeadNavRowLeft {
  left: 0;
  top: 0;
  z-index: 98;
}

.HeadNavRowContent {
  width: 3.4rem;
  left: calc(50% - 1.2rem);
  top: 0;
  margin: 0 auto;
  z-index: 98;
}

.HeadNavRowRight {
  right: 0;
  top: 0;
  z-index: 99;
}

.HeadNavRow:last-child {
  margin-right: 0;
}

.HeadNavTitle {
  font-size: .55rem;
  opacity: .85;
}

.HeadNavTxt {
  font-size: .45rem;
  margin-top: .1rem;
  line-height: .7rem;
  opacity: .95;
}

.iconyou {
  font-size: .4rem;
}

.MainBox {
  border-radius: .25rem;
  margin: .6rem;
  background-color: #FFF;
  box-shadow: 0 0 5px rgba(100, 100, 100, 0.2);
}

.MainTitle {
  font-size: .58rem;
  padding: .6rem;
  border-radius: .25rem .25rem 0 0;
  background-color: #F6F9FE;
  font-weight: 600;
  letter-spacing: .05rem;
}

.MainDatasBox {
  font-size: .58rem;
  padding: 0 .6rem;
  padding-bottom: 0.6rem;
  word-wrap: break-word;
  position: relative;
}

.MainData {
  line-height: .7rem;
  padding-top: .6rem;
  padding-bottom: .2rem;
  position: relative;
}

.MainData:after {
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}

.MainData:last-child {
  padding-bottom: 0;
}

.MainDataLeft {
  width: 5rem;
  float: left;
}

.MainDataRight {
  width: calc(100% - 5rem);
  float: right;
  text-align: right;
  color: #666;
}

.MainDataRightImg {
  width: 7rem !important;
  height: 4rem;
  overflow: hidden;
}

.MainDataHint {
  margin-top: .1rem;
  color: #666;
  font-size: .55rem;
}

.MainDataTip{
  line-height: 30px;
}

/* 溯源信息 */
.TraceData {
  padding-left: 1rem;
  padding-top: 0;
  padding-bottom: 1rem;
}

.TraceData:first-child {
  margin-top: .6rem;
}

.TraceDataDotBox {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: .45rem;
  height: .7rem;
  background-color: #FFF;
  z-index: 99;
}

.TraceDataDot {
  display: block;
  position: absolute;
  width: .3rem;
  height: .3rem;
  margin-top: .12rem;
  border: 2px solid #2C5DE8;
  border-radius: .3rem;
  z-index: 99;
}

.TraceDataDotBottomBox {
  top: auto;
  bottom: 0;
}

.TraceDataLine {
  display: block;
  position: absolute;
  top: .2rem;
  left: .186rem;
  bottom: 0;
  border-left: 2px dashed #2C5DE8;
  z-index: 98;
}

.VideoBox {
  margin-top: .6rem;
  width: 100%;
}

.MainRefDatasBox {
  padding: .6rem;
}

.MainRefDatasBox li:first-child {
  margin-top: 0;
}

.MainRefDatasBox li {
  line-height: .9rem;
  font-size: .58rem;
  margin-top: .3rem;
}

.MainRefDatasBox li img {
  display: block;
  width: 100%;
}

.MainRefDatasTxt {
  text-indent: .8rem;
}

.MainDataInquire {
  margin-top: 13px;
  border-radius: 3px;
  padding: 0 10px;
  height: 45px;
  font-size: 16px;
  width: calc(100% - 22.5px);
  border: 2px solid #317EF3;
}

.MainDataInquireBtn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 60px;
  line-height: 45px;
  display: table;
  background-color: #317EF3;
  text-align: center;
  color: #FFF;
  z-index: 99;
  border-radius: 0;
}

.NoBottom {
  padding-bototm: 0;
}

.Notop {
  margin-top: 0;
}
.MainMenuRow {
  padding: .5rem;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid #F3F3F3;
}

.MainMenuRow:last-child {
  border-bottom: 0;
}

.MainMenuIcon {
  float: left;
  width: 2.2rem;
  height: 2.2rem;
  margin-right: .5rem;
  border-radius: .2rem;
}

.MainMenuIcon i {
  display: block;
  width: 2.2rem;
  height: 2.2rem;
}

.MainMenuDatas {
  float: left;
  width: calc(100% - 3.5rem);
}

.MainMenuDatasTit {
  margin-top: .1rem;
  font-size: .58rem;
}

.MainMenuDatasTxt {
  font-size: .55rem;
  color: #666;
  margin-top: .15rem;
}

.MainMenuArrows {
  position: absolute;
  right: .5rem;
  top: calc(50% - .4rem);
  color: #666;
  font-size: .55rem;
}

.CliclStyle:active {
  background: #F6F6F6;
}

.CliclStyle:focus {
  background: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal28.vue